import Vue from 'vue';

import './assets/icons.css';

// search for icons on https://materialdesignicons.com/
Vue.component('icon-edit', () =>
  import('vue-material-design-icons/Pencil.vue')
);
Vue.component('icon-plus', () => import('vue-material-design-icons/Plus.vue'));
Vue.component('icon-delete', () =>
  import('vue-material-design-icons/Delete.vue')
);
Vue.component('icon-cog', () => import('vue-material-design-icons/Cog.vue'));
Vue.component('icon-loading', () =>
  import('vue-material-design-icons/Loading.vue')
);
Vue.component('icon-home', () =>
  import('vue-material-design-icons/HomeOutline.vue')
);
Vue.component('icon-plus-box', () =>
  import('vue-material-design-icons/PlusBoxOutline.vue')
);
Vue.component('icon-plus-box-multiple', () =>
  import('vue-material-design-icons/PlusBoxMultipleOutline.vue')
);
Vue.component('icon-copy', () =>
  import('vue-material-design-icons/ContentCopy.vue')
);
Vue.component('icon-link', () => import('vue-material-design-icons/Link.vue'));
Vue.component('icon-close', () =>
  import('vue-material-design-icons/Close.vue')
);
Vue.component('icon-star', () => import('vue-material-design-icons/Star.vue'));
Vue.component('icon-drag', () =>
  import('vue-material-design-icons/ArrowUpDown.vue')
);
Vue.component('icon-star-outline', () =>
  import('vue-material-design-icons/StarOutline.vue')
);
Vue.component('icon-expand-down', () =>
  import('vue-material-design-icons/ArrowExpandDown.vue')
);
Vue.component('icon-check', () =>
  import('vue-material-design-icons/Check.vue')
);
Vue.component('icon-alert', () =>
  import('vue-material-design-icons/AlertCircleOutline.vue')
);
Vue.component('icon-download', () =>
  import('vue-material-design-icons/DownloadCircleOutline.vue')
);
Vue.component('icon-external', () =>
  import('vue-material-design-icons/OpenInNew.vue')
);
